import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VDataTable, {
    staticClass: "mt-4",
    attrs: {
      headers: _vm.headers,
      items: _vm.value,
      "items-per-page": -1,
      "hide-default-footer": "",
      "hide-default-header": "",
    },
    scopedSlots: _vm._u(
      [
        {
          key: `item.avaliado`,
          fn: function ({ item }) {
            return [_vm._v(_vm._s(item.avaliacao.avaliado.nome))]
          },
        },
        {
          key: `item.rating`,
          fn: function ({ item }) {
            return [
              _c("app-rating", {
                attrs: {
                  value: item.nota,
                  disabled: _vm.disabled,
                  tamanho: _vm.value.length > 1 ? 28 : 36,
                },
                on: {
                  return: function ($event) {
                    item.naoAplica = false
                  },
                },
              }),
            ]
          },
        },
        {
          key: `item.switch`,
          fn: function ({ item }) {
            return [
              _c(
                VTooltip,
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "div",
                              _vm._g(
                                { staticStyle: { display: "inline-block" } },
                                on
                              ),
                              [
                                _c(VSwitch, {
                                  staticClass: "text-md-right",
                                  attrs: { label: "Não se aplica", dense: "" },
                                  on: {
                                    change: function ($event) {
                                      item.nota.rating = 0
                                    },
                                  },
                                  model: {
                                    value: item.naoAplica,
                                    callback: function ($$v) {
                                      _vm.$set(item, "naoAplica", $$v)
                                    },
                                    expression: "item.naoAplica",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c("span", [
                    _vm._v(
                      "Assinale a opção NÃO SE APLICA quando a responsabilidade não for executada pelo(a) avaliado(a)"
                    ),
                  ]),
                ]
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }